





































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { IntentListItemViewModel } from '@/features/bots/models/intents/intentListItemViewModel';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import FaqAddIntentModal from '@/features/bots/components/designer/FaqAddIntentModal.vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

@Component({
	components: {
		DropDownMenu,
		AddIcon,
		FaqAddIntentModal,
	},
	mixins: [validationMixin],
	validations: {
		selectedIntent: {
			required
		},
	}
})
export default class FaqIntentPicker extends Vue {
	@Prop() public intents: IntentListItemViewModel[];

	@Prop() public faqName!: string;

	@Prop() public intentId!: string | null;

	@Prop() public v: any;

	public selectedIntent: Partial<IntentListItemViewModel> | null = null;

	public $refs: {
		createIntentModal: FaqAddIntentModal
	};

	@Watch('intentId', { immediate: true })
	public onIntentIdChanged() {
		if (this.selectedIntentIsNewIntent()) {
			return;
		}
		const matchingIntentOnId = this.intents.find(i => i.id === this.intentId);
		if (matchingIntentOnId) {
			return this.selectIntent(matchingIntentOnId);
		}
		const matchingIntentOnName = this.intents.find(i => i.title === this.faqName);
		if (matchingIntentOnName) {
			return this.selectIntent(matchingIntentOnName);
		}
		return this.selectIntent({ title: this.faqName });
	}

	public addedIntent(intentTitle: string) {
		const existingIntent = this.intents.find(i => i.title === intentTitle);
		if (existingIntent) {
			this.selectIntent(existingIntent);
		} else {
			this.selectIntent({ title: intentTitle });
		}
	}

	public selectIntent(intent: Partial<IntentListItemViewModel>) {
		if (intent !== this.selectedIntent) {
			this.selectedIntent = intent;
			this.emitSelectedIntent();
		}
	}

	public openCreateIntentModal() {
		this.$refs.createIntentModal.showModal();
	}

	public get intentsForFaq() {
		return this.intents.filter(intent => intent.id !== 'None').sort((a, b) => a.title.localeCompare(b.title));
	}

	private selectedIntentIsNewIntent() {
		return this.selectedIntent !== null && this.selectedIntent?.id === undefined && this.selectedIntent?.title !== this.faqName;
	}

	private emitSelectedIntent() {
		this.$emit('input', this.selectedIntent);
	}
}
